export default {
  data () {
    return {
      isScreenSaver: false,
      timerToScreenSaver: 0
    }
  },
  methods: {
    measureTimeToScreenSaver () {
      clearTimeout(this.timerToScreenSaver)
      this.timerToScreenSaver = setTimeout(() => {
        // this.isScreenSaver = true
        location.href = 'https://customize.hh-online.jp/movie'
      }, 600000)
    }
  },
  mounted () {
    this.measureTimeToScreenSaver()
    window.addEventListener('touchstart', this.measureTimeToScreenSaver, false)
  }
}



// WEBPACK FOOTER //
// ./src/assets/class/ScreenSaver.js